import { render, staticRenderFns } from "./SelectionStatsCard.vue?vue&type=template&id=57993070"
import script from "./SelectionStatsCard.vue?vue&type=script&lang=js"
export * from "./SelectionStatsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports